import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import PreventEditComponent from "../../PreventEditComponent";
import SvgImage from "../../SvgImage";

type Props = {
	handleOnPressEdit: (tabName: IActiveTabs) => void;
};

const ReviewPermanentDetails: React.FC<Props> = (props: Props) => {
	const { handleOnPressEdit } = props;

	const { values } = useFormikContext<IFormITR1>();
	const FullName = `${values?.FirstName || ""} ${values?.MiddleName || ""} ${
		values?.SurNameOrOrgName || ""
	}`;

	return (
		<>
			<Accordion.Item eventKey="review-file-0">
				<Accordion.Header>
					<div className="btn-content">
						<SvgImage imgId="permanent-information" />
						<h4 className="mb-0">Permanent Details</h4>
					</div>
					<PreventEditComponent>
						<span
							role="button"
							className="btn btn-link"
							onClick={() => handleOnPressEdit("personal-details")}
						>
							Edit
						</span>
					</PreventEditComponent>
				</Accordion.Header>
				<Accordion.Body>
					<hr />
					<section>
						<dl className="eds-list eds-dl eds-inline-between">
							<div className="eds-list--item">
								<dt>Assessment Year</dt>
								<dd>2023-24</dd>
							</div>
							<div className="eds-list--item">
								<dt>ITR Type</dt>
								<dd>{values.FilingReturnInfo?.FormName}</dd>
							</div>
							<div className="eds-list--item">
								<dt>Name</dt>
								<dd>{FullName}</dd>
							</div>
							<div className="eds-list--item">
								<dt>Date of birth</dt>
								<dd>{values?.DOB}</dd>
							</div>
							<div className="eds-list--item">
								<dt>PAN</dt>
								<dd>{values?.PAN}</dd>
							</div>
							<div className="eds-list--item">
								<dt>Residential Status</dt>
								<dd>{values?.Address?.ResidentialStatus}</dd>
							</div>
						</dl>
					</section>
				</Accordion.Body>
			</Accordion.Item>
		</>
	);
};

export default ReviewPermanentDetails;
